function subPageField(type) {
  if (type === 'school') {
    return 'School URL Slug'
  } else if (type === 'network') {
    return 'Current Network'
  } else if (type === 'councilDistrict') {
    return 'CityCouncilDistrict'
  } else if (type === 'studyArea') {
    return 'CSPR Study Area'
  } else if (type === 'sector') {
    return 'Sector'
  } else if (type === 'citywide') {
    return 'citywide'
  }
}

export { subPageField }
